export const publicMarketingNavItems = [
  { label: "Roadmap", href: "/roadmap", matches: ["/roadmap", "/public/roadmap"] },
  { label: "Stellenbörse", href: "/stb/job-marketplace", matches: ["/stb/job-marketplace"] },
  { label: "Leitbild", href: "/leitbild", matches: ["/leitbild"] },
  { label: "Support", href: "/menue/support", matches: ["/menue/support"] },
];

export const publicAuthNavItems = [
  { label: "Startseite", href: "/", matches: ["/"] },
  { label: "Roadmap", href: "/roadmap", matches: ["/roadmap", "/public/roadmap"] },
  { label: "Jobs", href: "/stb/job-marketplace", matches: ["/stb/job-marketplace"] },
  { label: "Support", href: "/menue/support", matches: ["/menue/support"] },
];

export const publicFooterGroups = [
  {
    title: "Navigation",
    items: [
      { label: "Startseite", href: "/" },
      { label: "Roadmap", href: "/roadmap" },
      { label: "Leitbild", href: "/leitbild" },
      { label: "Stellenbörse", href: "/stb/job-marketplace" },
    ],
  },
  {
    title: "Orientierung",
    items: [
      { label: "Support", href: "/menue/support" },
      { label: "Tools", href: "/menue/tools" },
      { label: "Qualifikationen", href: "/menue/quali" },
      { label: "Erfolg", href: "/menue/success" },
    ],
  },
  {
    title: "Rechtliches",
    items: [
      { label: "Impressum", href: "/impressum" },
      { label: "AGB", href: "/agb" },
      { label: "Datenschutz", href: "/datenschutz" },
    ],
  },
];

export const publicFamilyAuditRoutes = [
  "/",
  "/leitbild",
  "/roadmap",
  "/public/roadmap",
  "/login",
  "/register",
  "/applicant/frontdoor",
  "/menue/support",
  "/menue/tools",
  "/menue/quali",
  "/menue/success",
  "/impressum",
  "/agb",
  "/datenschutz",
  "/stb/job-marketplace",
];

export function isPublicNavItemActive(item, pathname) {
  const normalizedPath = String(pathname || "").split("?")[0];
  const matches = Array.isArray(item?.matches) && item.matches.length ? item.matches : [item?.href];
  return matches.some((value) => value === normalizedPath);
}
